import { ICartPricesCustom } from '@common/hooks/useVatCalculation';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CartPricesState {
  cartPrices: ICartPricesCustom[];
}

const initialState: CartPricesState = {
  cartPrices: [],
};

const cartPricesSlice = createSlice({
  name: 'cartPrices',
  initialState,
  reducers: {
    setCartPrices: (state, action: PayloadAction<ICartPricesCustom[]>) => {
      state.cartPrices = action.payload;
    },
  },
});

export const { setCartPrices } = cartPricesSlice.actions;
export default cartPricesSlice.reducer;
